import React, { ReactElement, useMemo, MouseEvent, memo } from "react";
import {
  OverlayTrigger as RcOverlayTrigger,
  OverlayTriggerProps as RcOverlayTriggerProps,
} from "react-bootstrap";
import { OverlayTriggerType } from "react-bootstrap/esm/OverlayTrigger";

const POLYFILL_BROWSERS = ["Safari"] as const;
const POLYFILL_TRIGGERS: Readonly<OverlayTriggerType[]> = ["focus"];

export type OverlayTriggerProps = Omit<RcOverlayTriggerProps, "children"> & {
  children: ReactElement;
};

/**
 * renders an OverlayTrigger w/ browser compatibility polyfill
 */
const OverlayTrigger = ({
  children,
  trigger,
  ...props
}: OverlayTriggerProps) => {
  const nextChildren = useMemo((): OverlayTriggerProps["children"] => {
    if (
      !trigger ||
      POLYFILL_BROWSERS.every((el) => !navigator.userAgent.includes(el))
    ) {
      return children;
    }

    if (POLYFILL_TRIGGERS.some((el) => trigger.includes(el))) {
      // manually focus
      return React.cloneElement(children, {
        onClick: (e: MouseEvent<HTMLElement>) => {
          (e.target as HTMLElement).focus();
          if (children.props.onClick) {
            return children.props.onClick(e);
          }
          return e;
        },
      });
    }

    return children;
  }, [trigger, children]);
  return (
    <RcOverlayTrigger {...props} children={nextChildren} trigger={trigger} />
  );
};

export default memo(OverlayTrigger);
